import { useEffect, useRef, useState } from "react";
import Button from "@/common/elements/Button";
import DataTable from "@/common/elements/DataTable";
import {
  StyledFlex,
  StyledGridCol,
  StyledGridRow,
  StyledSectionHeading,
  StyledSubTableContainer,
} from "@/common/styles";
import CustomModal from "@/components/CustomModal";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import { useDispatch, useSelector } from "react-redux";
import { setBookings } from "@/slices/bookingsSlice";
import CashAccountPaymentForm from "../../pages/Warrants/components/CashAccountPaymentForm";
import CashAccountDetailForm from "../../pages/Warrants/components/CashAccountDetailForm";
import dayjs from "dayjs";
import { isNonEmptyVariable } from "@/util/common_function";

const CashAccountDetails = ({}) => {
  const dispatch = useDispatch();

  const [detailsModal, setDetailsModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [feeOrFineModal, setFeeOrFineModal] = useState(false);
  const [cashDetails, setCashDetails] = useState();
  const [selectedIndex, setSelectedIndex] = useState();
  const [selectedData, setSelectedData] = useState();

  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );

  const tableHeaders = [
    { key: "id", text: "#" },
    { key: "dateTime", text: "Date Time" },
    { key: "user", text: "User" },
    { key: "category", text: "Category" },
    { key: "amount", text: "Amount" },
    { key: "transactionDetails", text: "Transaction Details" },
    { key: "receiptNumber", text: "Receipt Number" },
    { key: "transactionType", text: "Transaction Type" },
  ];

  const inmateCashAccountRef = {
    cashDeposit: useRef(),
    purchase: useRef(),
  };

  useEffect(() => {
    const data =
      bookings.bookingCashAccount?.[0]?.cashAccountingNewTransactions?.map(
        (cashAccountData, index) => ({
          id: index,
          dateTime: null,
          user: cashAccountData?.user,
          category: cashAccountData?.category,
          amount: cashAccountData?.amount,
          transactionDetails: cashAccountData?.transactionDetails,
          receiptNumber: cashAccountData?.receiptNumber,
          transactionType: cashAccountData?.transactionType,
        })
      );
    setCashDetails(data);
  }, []);

  const handleDeposit = () => {
    setPaymentModal(!paymentModal);
  };

  const handlePurchase = () => {
    setFeeOrFineModal(!feeOrFineModal);
  };

  const handleDetailsModal = () => {};

  const handleDelete = () => {};

  const handleOnSave = async () => {
    let values;
    try {
      if (paymentModal) {
        await inmateCashAccountRef.cashDeposit.current.validateFields();
        values = inmateCashAccountRef.cashDeposit.current.getFormValues();
      } else {
        await inmateCashAccountRef.purchase.current.validateFields();
        values = inmateCashAccountRef.purchase.current.getFormValues();
      }
    } catch (err) {
      return;
    }

    const targetAccount = structuredClone(
      bookings?.bookingCashAccount?.[0] || {}
    );
    const transactions = [
      ...(targetAccount?.cashAccountingNewTransactions || []),
    ];

    if (detailsModal) {
      const transactionIndex = transactions.findIndex(
        (tx) => tx.receiptNumber === updatedTransaction.receiptNumber
      );

      if (transactionIndex !== -1) {
        transactions[transactionIndex] = {
          ...transactions[transactionIndex],
          ...values,
        };
      }
    } else {
      const newTransaction = {
        ...values,
        dateAdded: dayjs(values?.expectedBackDateTime)?.format("MM/DD/YYYY"),
        timeAdded: dayjs(values?.expectedBackDateTime)?.format("HH:mm"),
      };
      transactions.push(newTransaction);
    }
    targetAccount.cashAccountingNewTransactions = transactions;
    dispatch(setBookings({ bookingCashAccount: [targetAccount] }));

    setPaymentModal(false);
    setDetailsModal(false);
    setFeeOrFineModal(false);
  };

  // const tableData = [
  //   {
  //     cashAccountingTransactionId: null,
  //     cashAccountingId: null,
  //     transactionType: "Credit",
  //     dateAdded: "06/25/2006",
  //     timeAdded: "02:30",
  //     user: null,
  //     enteredBy: null,
  //     enteredByBadge: null,
  //     "	": null,
  //     category: "Deposit",
  //     receiptNumber: "136358",
  //     sequence: 1,
  //     receivedBy: null,
  //     receivedByBadge: null,
  //     checkNumber: null,
  //     categoryId: null,
  //     creatorStaffId: 97,
  //     receivedByStaffId: 97,
  //     depositType: "Cash",
  //     autoGenerated: false,
  //     relatedField: null,
  //     percentage: null,
  //     amount: 350.0,
  //     serviceAttemptId: null,
  //   },
  //   {
  //     cashAccountingTransactionId: null,
  //     cashAccountingId: null,
  //     transactionType: "Debit",
  //     dateAdded: "06/25/2006",
  //     timeAdded: "02:30",
  //     user: null,
  //     enteredBy: null,
  //     enteredByBadge: null,
  //     "	": null,
  //     category: "Deposit",
  //     receiptNumber: "136358",
  //     sequence: 1,
  //     receivedBy: null,
  //     receivedByBadge: null,
  //     checkNumber: null,
  //     categoryId: null,
  //     creatorStaffId: 97,
  //     receivedByStaffId: 97,
  //     depositType: "Cash",
  //     autoGenerated: false,
  //     relatedField: null,
  //     percentage: null,
  //     amount: 350.0,
  //     serviceAttemptId: null,
  //   },
  // ];

  const handleRowClick = (e, i) => {};

  return (
    <>
      <StyledSectionHeading marginBottom="0px" marginTop="20px">
        <span>Cash Account</span>
      </StyledSectionHeading>

      <StyledSubTableContainer>
        <StyledFlex justify="space-between" align="center" marginBottom="5px">
          <h2 style={{ margin: "0" }}>Account Transactions</h2>
          <StyledFlex gap="10px">
            <Button onClick={handleDeposit}>Deposit</Button>
            <Button onClick={handlePurchase}>Purchase</Button>
            <Button onClick={handleDetailsModal} disabled={!selectedData}>
              Details
            </Button>
            <Button onClick={handleDelete} disabled={!selectedData}>
              Delete
            </Button>
          </StyledFlex>
        </StyledFlex>

        <DataTable
          headers={tableHeaders}
          data={
            bookings?.bookingCashAccount?.[0]?.cashAccountingNewTransactions ||
            []
          }
          // onRowClick={handleRowClick}
        />
        <div style={{ textAlign: "right" }}>
          <span>
            <b>Balance:</b>{" "}
          </span>
        </div>
      </StyledSubTableContainer>

      <StyledGridRow gutter={16}>
        <StyledGridCol lg={24} marginTop="15px">
          <FormItem label="Comments">
            <TextField inputType="textarea" rows="2" />
          </FormItem>
        </StyledGridCol>
      </StyledGridRow>

      {detailsModal && (
        <CustomModal
          show={detailsModal}
          onHide={() => setDetailsModal(false)}
          header="Cash Account Transaction"
          size="lg"
        >
          <CashAccountDetailForm />
        </CustomModal>
      )}

      {paymentModal && (
        <CustomModal
          show={paymentModal}
          onHide={() => setPaymentModal(false)}
          onSaveClick={handleOnSave}
          header="Enter New Payment For This Account"
          size="lg"
        >
          <CashAccountPaymentForm
            depositFormRef={inmateCashAccountRef.cashDeposit}
          />
        </CustomModal>
      )}

      {feeOrFineModal && (
        <CustomModal
          show={feeOrFineModal}
          onHide={() => setFeeOrFineModal(false)}
          onSaveClick={handleOnSave}
          header="Enter New Fee/Fine For This Account"
          size="lg"
        >
          <CashAccountDetailForm
            purchaseFormRef={inmateCashAccountRef.purchase}
          />
        </CustomModal>
      )}
    </>
  );
};
export default CashAccountDetails;
